module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/ruler-combined.svg?8c9bcf8d912569a1a2329090165b9c36";